import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=c6db7d82&scoped=true"
import script from "./Comentarios.vue?vue&type=script&lang=js"
export * from "./Comentarios.vue?vue&type=script&lang=js"
import style0 from "./Comentarios.vue?vue&type=style&index=0&id=c6db7d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6db7d82",
  null
  
)

export default component.exports